// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscriptions_no_data__mxNwH {
  text-align: center;
  font-size: 18px;
  color: var(--text-secondary-color);
}

.subscriptions_SubscriptionsModal__hiRmr .comment_content_wrap {
  max-width: 600px;
}

.subscriptions_SubscriptionsModalContent__1eKbW > div {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.subscriptions_SubscriptionButton__pcvvY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 2px solid var(--primary-color);
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.subscriptions_SubscriptionButton__pcvvY:hover {
  background-color: var(--primary-color-hover);
  color: #fff;
  transform: scale(1.01);
}
.subscriptions_SubscriptionButton__pcvvY:hover .subscriptions_price__SafMJ {
  color: #fff;
}
.subscriptions_SubscriptionButton__pcvvY:active {
  background-color: var(--primary-color);
  color: #fff;
  transform: scale(0.98);
}
.subscriptions_SubscriptionButton__pcvvY .subscriptions_price__SafMJ {
  color: var(--secondary-color);
}
.subscriptions_SubscriptionButton__pcvvY .subscriptions_price__SafMJ .subscriptions_currency__V4-ID {
  margin-left: 4px;
  font-size: 16px;
}

.subscriptions_selectedSubscription__tduRN {
  background-color: var(--primary-color);
  color: #fff;
  border-color: var(--primary-color-hover);
}
.subscriptions_selectedSubscription__tduRN .subscriptions_price__SafMJ {
  color: #fff;
}

.subscriptions_PurchaseSubscriptionButton__yhzO5 {
  margin: 12px auto 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Dialogs/Subscriptions/subscriptions.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,eAAA;EACA,kCAAA;AACD;;AAGC;EACC,gBAAA;AAAF;;AAKC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAMA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,gCAAA;AAHD;AAKC;EACC,4CAAA;EACA,WAAA;EACA,sBAAA;AAHF;AAKE;EACC,WAAA;AAHH;AAOC;EACC,sCAAA;EACA,WAAA;EACA,sBAAA;AALF;AAQC;EACC,6BAAA;AANF;AAQE;EACC,gBAAA;EACA,eAAA;AANH;;AAWA;EACC,sCAAA;EACA,WAAA;EACA,wCAAA;AARD;AAUC;EACC,WAAA;AARF;;AAYA;EACC,mBAAA;AATD","sourcesContent":[".no_data {\n text-align: center;\n font-size: 18px;\n color: var(--text-secondary-color);\n}\n\n.SubscriptionsModal {\n :global(.comment_content_wrap) {\n  max-width: 600px;\n }\n}\n\n.SubscriptionsModalContent {\n & > div {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n }\n}\n\n.SubscriptionButton {\n display: flex;\n align-items: center;\n justify-content: space-between;\n width: 100%;\n height: 100%;\n background-color: transparent;\n border: 2px solid var(--primary-color);\n padding: 12px 24px;\n border-radius: 8px;\n font-size: 24px;\n font-weight: 700;\n color: var(--primary-color);\n cursor: pointer;\n transition: all 0.3s ease-in-out;\n\n &:hover {\n  background-color: var(--primary-color-hover);\n  color: #fff;\n  transform: scale(1.01);\n\n  .price {\n   color: #fff;\n  }\n }\n\n &:active {\n  background-color: var(--primary-color);\n  color: #fff;\n  transform: scale(0.98);\n }\n\n .price {\n  color: var(--secondary-color);\n\n  .currency {\n   margin-left: 4px;\n   font-size: 16px;\n  }\n }\n}\n\n.selectedSubscription {\n background-color: var(--primary-color);\n color: #fff;\n border-color: var(--primary-color-hover);\n\n .price {\n  color: #fff;\n }\n}\n\n.PurchaseSubscriptionButton {\n margin: 12px auto 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no_data": `subscriptions_no_data__mxNwH`,
	"SubscriptionsModal": `subscriptions_SubscriptionsModal__hiRmr`,
	"SubscriptionsModalContent": `subscriptions_SubscriptionsModalContent__1eKbW`,
	"SubscriptionButton": `subscriptions_SubscriptionButton__pcvvY`,
	"price": `subscriptions_price__SafMJ`,
	"currency": `subscriptions_currency__V4-ID`,
	"selectedSubscription": `subscriptions_selectedSubscription__tduRN`,
	"PurchaseSubscriptionButton": `subscriptions_PurchaseSubscriptionButton__yhzO5`
};
export default ___CSS_LOADER_EXPORT___;
